module.exports = __webpack_public_path__ + "img/img7.39436ab9.png";